import "@tento-ui/components/nux-habit-card/habit-card";

import { Storybook } from "@tento-ui/ui/storybook";
import { CheckSquareIcon, LonaIcons } from "@tento-ui/ui/icons";
import { NuxHabitCard } from "@tento-ui/components/nux-habit-card/habit-card";
import { $makeHomeCard } from "@tento-ui/components/home-card/home-grid-card.example";
import { Tracing } from "@tento-core/tracing";

const exampleCallbacks: NuxHabitCard.Callbacks = {
  onAddHabit: (habit) => Tracing.dev("storybook", "Add habit clicked", habit),
};

export class NuxHabitCardStoryBook extends Storybook.Default {
  title(): string {
    return "Nux Habit Card";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "In Context",
        render: () =>
          $makeHomeCard({
            title: "Add a Habit",
            icon: LonaIcons.$template(CheckSquareIcon),
            contentBg: "var(--bg-surface-light-opaque)",
            $cardContent: NuxHabitCard.makeWith(exampleCallbacks),
          }),
      },
      {
        title: "Raw",
        render: () => NuxHabitCard.makeWith(exampleCallbacks),
      },
    ];
  }
}
